import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Join as a Volunteer",
    text: "Support field teams, teach students, or help coordinate community events."
  },
  {
    title: "Join as a Partner",
    text: "Collaborate on CSR initiatives, supply chains, and on-the-ground programs."
  },
  {
    title: "Join as a Donor",
    text: "Build long-term impact through monthly or project-specific contributions."
  }
];

function JoinUs() {
  return (
    <SimplePage
      title="Join Us"
      lead="Whether you volunteer, partner, or donate, your involvement amplifies impact."
      sections={sections}
    />
  );
}

export default JoinUs;
